import { useContext, useState } from "react";
import { observer } from "mobx-react";
import { StepProps } from "../../../../stores/models/Step";
import { RootContext } from "../../../../stores";
import { Fields } from "../../../../stores/models/Fields";
import { LogoutOrProfileSwitchRequiredForm } from "../../../../modules/authentication/components/LogoutOrProfileSwitchRequiredForm";
import { useLogoutOrProfileSwitchRequiredController } from "./useLogoutOrProfileSwitchRequiredController";
import { ILogoutOrProfileSwitchRequiredFormValues } from "../../../../modules/authentication/_interfaces/ILogoutOrProfileSwitchRequiredFormValues";

const InvalidUserTypeStep = observer(<T extends Fields<Partial<T>, T>>(props: StepProps<T>) => {

    const rootStore = useContext(RootContext);
    const userStore = rootStore.userStore;
    const user = userStore.user;

    const [values, setValues] = useState({
        currentUserEmail: user.email,
        currentUserName: user.name,
        prompt: user.hasVolunteerProfile
            ? "You're using an organization administrator profile right now. In order to proceed, please switch to your volunteer profile or logout and log back in to another volunteer account."
            : "You're logged into your organization's account at the moment. Please logout and then log back in as a volunteer in order to proceed.",
        allowSwitch: user.hasVolunteerProfile
    } as ILogoutOrProfileSwitchRequiredFormValues);

    const update = (patch: Partial<any>) => {
        setValues((v) => ({ ...v, ...patch }));
    };

    const controller = useLogoutOrProfileSwitchRequiredController(values, update);

    /***** Render *****/

    return (
        <LogoutOrProfileSwitchRequiredForm
            values={controller.values}
            onChange={(patch) => {
                controller.onChange(patch);
                update(patch);
            }}
            onSubmit={controller.onSubmit}
            isSubmitting={controller.isSubmitting}
            error={controller.error}
            fieldErrors={controller.fieldErrors}
        />
    );
});

export default InvalidUserTypeStep;